import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var approvalRes;
export const approvalTodo = createAsyncThunk('approval', async (data) => {


    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard_so_pending_approval',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcust_plant_code": localStorage.getItem('vcust_plant_code')
            }
        })
        return approvalRes = res.data

    } catch (error) {
        return approvalRes = error.response.data
    }
});

const approvalSlice = createSlice({
    name: 'approval',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(approvalTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(approvalTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default approvalSlice.reducer; 